const hexToRgbChannels = (hex) => {
  if (typeof hex !== 'string') return null;

  const value = hex.trim().replace('#', '');
  const full =
    value.length === 3 ? value.split('').map((c) => c + c).join('') : value;

  if (!/^[0-9a-fA-F]{6}$/.test(full)) return null;

  const int = parseInt(full, 16);
  return `${(int >> 16) & 255}, ${(int >> 8) & 255}, ${int & 255}`;
};

export default hexToRgbChannels;
